import withLayout from '../../hoc/with-layout';
import ListViewScreenController from './list-view-screen.controller';

const ListViewScreen = () => {
  return <ListViewScreenController />;
};

export default withLayout(ListViewScreen);
